import { Observable } from 'rxjs';
import { RxDealsHttpClient } from '../../../../shared/_services/server-clients';
import type { ExchangeDeal } from '../../../../shared/_models/models';
import type { ResponseFromServer } from '../../../../shared/_models/response-from-server.model';

export class ExchangeDealFormApiService {
  constructor(private readonly rxDealsHttpClient: RxDealsHttpClient) {}

  createExchangeDeal(currentDeal: ExchangeDeal): Observable<ResponseFromServer<ExchangeDeal>> {
    const relativePath = 'deals';
    return this.rxDealsHttpClient.postRaw<ExchangeDeal, ExchangeDeal>(relativePath, currentDeal);
  }
}
